import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  TYPE_INSTANCE4,
} from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  convertToValidPrice,
  defaultToastError,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { trim } from "lodash";
import { useContext, useState } from "react";
import { FormContext } from "../context/FormContext";

export const ModalBarang = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewDataPoList,
  setListPO,
  listPO,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const { formData } = useContext(FormContext);
  const satuan = useSelectOption(
    true,
    "/wmsMasterAsset/satuan/list",
    TYPE_INSTANCE4
  );

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (isNull(formBarang.nama_barang)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama barang tidak boleh kosong!");
    } else {
      if (isNull(formBarang.qty) || formBarang.qty <= 0) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError("Banyak barang tidak boleh kosong!");
      } else {
        if (isNull(formBarang.harga2) || formBarang.harga2 <= 0) {
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          defaultToastError("Harga barang tidak boleh kosong!");
        } else {
          if (!isNull(formBarang.satuan_id)) {
            try {
              if (isNull(formBarang.id)) {
                // Tanpa ID
                if (formBarang.onCreate) {
                  // Tambah Baru
                  const barang = listPO;
                  const checkNamaBarang = barang.filter(
                    (e) =>
                      e.nama_barang.toUpperCase() ===
                      formBarang.nama_barang.toUpperCase()
                  );
                  if (checkNamaBarang.length === 0) {
                    const barang = listPO;
                    barang.push({
                      id: null,
                      nama_barang: trim(formBarang?.nama_barang),
                      namasatuan: formBarang?.namasatuan,
                      satuan_id: formBarang?.satuan_id,
                      qty: formBarang.qty,
                      harga: convertToValidPrice(formBarang.harga2),
                      disc: formBarang.disc,
                      remark: "",
                      set_disc:
                        (formBarang.disc / 100) *
                        (convertToValidPrice(formBarang.harga2) *
                          formBarang.qty),
                    });
                    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                    setShowModal(false);
                  } else {
                    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                    defaultToastError(
                      "Tidak dapat menambahkan barang yang sama !"
                    );
                  }
                } else {
                  // Update Barang Tanpa ID
                  const barang = listPO;
                  if (
                    formBarang.nama_barang.toUpperCase() ===
                    formBarang.nama_barang2.toUpperCase()
                  ) {
                    // Tidak ada perubahan nama barang
                    const checkBarang = barang.filter(
                      (e) =>
                        e.nama_barang.toUptoUpperCase() !==
                        formBarang.nama_barang.toUpperCase()
                    );
                    checkBarang.push({
                      id: formBarang?.id,
                      nama_barang: trim(formBarang?.nama_barang),
                      namasatuan: formBarang?.namasatuan,
                      satuan_id: formBarang?.satuan_id,
                      qty: formBarang.qty,
                      harga: convertToValidPrice(formBarang.harga2),
                      disc: formBarang.disc,
                      remark: "",
                      set_disc:
                        (formBarang.disc / 100) *
                        (convertToValidPrice(formBarang.harga2) *
                          formBarang.qty),
                    });
                    setListPO(checkBarang);
                    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                    setShowModal(false);
                  } else {
                    // Terdapat perubahan nama barang
                    const checkNamaBarang = barang.filter(
                      (e) =>
                        e.nama_barang.toUpperCase() ===
                        formBarang.nama_barang.toUpperCase()
                    );

                    if (checkNamaBarang.length === 0) {
                      const checkBarang = barang.filter(
                        (e) => e.nama_barang !== formBarang.nama_barang2
                      );

                      checkBarang.push({
                        id: formBarang?.id,
                        nama_barang: trim(formBarang?.nama_barang),
                        namasatuan: formBarang?.namasatuan,
                        satuan_id: formBarang?.satuan_id,
                        qty: formBarang.qty,
                        harga: convertToValidPrice(formBarang.harga2),
                        disc: formBarang.disc,
                        remark: "",
                        set_disc:
                          (formBarang.disc / 100) *
                          (convertToValidPrice(formBarang.harga2) *
                            formBarang.qty),
                      });
                      setListPO(checkBarang);
                      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                      setShowModal(false);
                    } else {
                      defaultToastError("Nama barang sudah ditambahkan!");
                      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                    }
                  }
                }
              } else {
                // Dengan ID
                const barang = listPO;
                const checkIdBarang = barang.filter(
                  (e) => e.id === formBarang.id
                );
                if (checkIdBarang.length === 0) {
                  setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                  defaultToastError("ID Barang tidak ditemukan !");
                } else {
                  // ID ditemukan
                  if (
                    formBarang.nama_barang.toUpperCase() ===
                    formBarang.nama_barang2.toUpperCase()
                  ) {
                    const checkBarang = barang.filter(
                      (e) => e.id !== formBarang.id
                    );
                    checkBarang.push({
                      id: formBarang?.id,
                      nama_barang: trim(formBarang?.nama_barang),
                      namasatuan: formBarang?.namasatuan,
                      satuan_id: formBarang?.satuan_id,
                      qty: formBarang.qty,
                      harga: convertToValidPrice(formBarang.harga2),
                      disc: formBarang.disc,
                      remark: "",
                      set_disc:
                        (formBarang.disc / 100) *
                        (convertToValidPrice(formBarang.harga2) *
                          formBarang.qty),
                    });
                    setListPO(checkBarang);
                    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                    setShowModal(false);
                  } else {
                    const checkNamaBarang = barang.filter(
                      (e) =>
                        e.nama_barang.toUpperCase() ===
                          formBarang.nama_barang.toUpperCase() &&
                        e.id !== formBarang.id
                    );
                    if (checkNamaBarang.length === 0) {
                      const checkBarang = barang.filter(
                        (e) => e.id !== formBarang.id
                      );
                      checkBarang.push({
                        id: formBarang?.id,
                        nama_barang: trim(formBarang?.nama_barang),
                        namasatuan: formBarang?.namasatuan,
                        satuan_id: formBarang?.satuan_id,
                        qty: formBarang.qty,
                        harga: convertToValidPrice(formBarang.harga2),
                        disc: formBarang.disc,
                        remark: "",
                        set_disc:
                          (formBarang.disc / 100) *
                          (convertToValidPrice(formBarang.harga2) *
                            formBarang.qty),
                      });
                      setListPO(checkBarang);
                      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                      setShowModal(false);
                    } else {
                      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                      defaultToastError(
                        "Tidak dapat mengubah dengan nama barang yang sama !"
                      );
                    }
                  }
                }
              }
            } catch (error) {
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
              defaultToastError(error?.response?.data?.message);
            }
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError("Satuan beli tidak boleh kosong");
          }
        }
      }
    }
  };

  // const succesCreateOrUpdate = async (label) => {
  //   defaultToastSuccess(`Berhasil ${label} Barang`);
  //   const res = await getPoListById(formData.idpo);
  //   setListPO(res.data);

  // };

  return (
    <Modal
      title={formBarang.onCreate ? "Tambah Barang" : "Ubah Barang"}
      show={setShowModal}
      width='40%'>
      {
        <form action='POST' onSubmit={(e) => handleSubmit(e)}>
          <p className='mt-1 mb-1'>{formBarang.namabarang}</p>
          <Grid container spacing={1}>
            <InputTextMaster
              type='hidden'
              name='barang_id'
              id='barang_id'
              readOnly={true}
              value={formBarang.barang_id}
            />
            <Grid item sm={12}>
              <InputTextMaster
                label='NAMA BARANG'
                name='nama_barang'
                id='nama_barang'
                value={formBarang.nama_barang}
                onChange={handleChange("nama_barang")}
                placeholder='Nama Barang'
              />
            </Grid>

            <Grid item sm={4}>
              <InputOptionMaster
                name='satuan_id'
                label='SATUAN'
                id='satuan_id'
                withSearch={true}
                // disabled={formData.isRequest ? true : false}
                data={satuan}
                value={formBarang.satuan_id}
                labelValue={formBarang.namasatuan}
                onChange={(e) => {
                  if (formData.isRequest === false) {
                    if (isNull(e)) {
                      setFormBarang({
                        ...formBarang,
                        satuan_id: null,
                        namasatuan: "Pilih Satuan",
                      });
                    } else {
                      setFormBarang({
                        ...formBarang,
                        satuan_id: e.value,
                        namasatuan: e.label,
                      });
                    }
                  }
                }}
              />
            </Grid>
            <Grid item sm={2}>
              <InputTextMaster
                name='qty'
                label='BANYAK'
                id='qty'
                // disabled={formData.isRequest ? true : false}
                value={formBarang.qty}
                onChange={handleChange("qty")}
                placeholder='Banyak'
              />
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name='harga'
                label='HARGA'
                id='harga'
                placeholder='0'
                value={formBarang.harga2}
                onInput={(e) => {
                  let val = e.target.value;
                  setFormBarang({
                    ...formBarang,
                    harga2: formatRupiah(val),
                  });
                }}
                withButtonLeft={true}>
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderLeft: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderRight: "0",
                    background: "#fff",
                    padding: "0 0 0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "6px 0 0 6px",
                    fontSize: "10px",
                  }}>
                  Rp.
                </button>
              </InputTextMaster>
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name='disc'
                label='DISC %'
                id='disc'
                value={formBarang.disc}
                onChange={handleChange("disc")}
                placeholder='0'
                withButton={true}>
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderRight: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderLeft: "0",
                    background: "#fff",
                    padding: "0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "0 6px 6px 0",
                  }}>
                  %
                </button>
              </InputTextMaster>
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            justifyContent='flex-end'
            alignItems='center'>
            <MasterButton
              className={"mt-1"}
              type='submit'
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.disabled}
              size='md'
            />
          </Grid>
        </form>
      }
    </Modal>
  );
};
